$(function () {
    var Swiper = require('swiper').default;
    var GLightbox = require('glightbox');

    function initSwiper() {
        if ($('.swiper-container').length === 0) return;
        new Swiper('.swiper-container', {
            slidesPerView: 'auto',
            spaceBetween: 10,
            centeredSlides: false,
            navigation: false
        });
        GLightbox();
    }

    $('#modal').on('shown.bs.modal', function () {
        initSwiper();
    })
});
